var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-header full-width" }, [
    _c(
      "div",
      { staticClass: "page-header-not-fixed-invisible-wrapper base-wrapper" },
      [
        _c(
          "div",
          { staticClass: "page-header-left-side" },
          [
            _c("breadcrumbs", { attrs: { links: _vm.links } }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "page-header-title-container" },
              [
                _c(
                  "heading",
                  {
                    staticClass: "page-header-title-value",
                    attrs: { level: "h2" },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.title) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm._t("default"),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "page-header-fixed-wrapper base-wrapper" },
      [
        _c(
          "div",
          { staticClass: "page-header-left-side" },
          [
            _c("breadcrumbs", { attrs: { links: _vm.links } }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "page-header-title-container" },
              [
                _c(
                  "heading",
                  {
                    staticClass: "page-header-title-value",
                    attrs: { level: "h2" },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.title) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm._t("default"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }